import { getImageWithFallback } from "../../helpers/ImageHelpers";

export type OrderItem = {
  order_item_id: number;
  ref_type: string;
  ref_id: string;

  name: string; // Product name
  quantity: number;
  unit_price: number;
  discount: number;
  total: number;
  is_locked: number;
  meta: Record<string, any>;

  // Optional
  currency?: string;
  product_image?: string;
  variant_name?: string;
};

type OrderCardOrderItemsListProps = {
  items: OrderItem[];
};

const OrderCardOrderItemsList: React.FC<OrderCardOrderItemsListProps> = ({ items }) => {
  if (!items || items.length === 0) {
    return <div className="text-gray-400 text-sm px-2 py-1">No items</div>;
  }

  return (
    <div className="flex flex-col max-h-full overflow-y-auto rounded-lg pt-1 text-gray-600 bg-white">
      {items.map((item, idx) => {
        const currency = item.currency || "RF";
        const price = item.unit_price_display || 0;
        const quantity = item.quantity || 1;
        const discount = item.discount_display || 0;
        const total = item?.total_display || 0;

        return (
          <div key={item.order_item_id}>
            <div className="w-full flex gap-2 py-1 items-start text-[12px] px-1">
              {/* Product image */}
              <div className="w-9 h-9 flex flex-col justify-between items-center text-center">
                <div className="h-8 w-8 ring-1 rounded-md ring-gray-200 flex justify-center items-center bg-gray-50 overflow-hidden">
                  {getImageWithFallback({ originalUrl: item.product_image })}
                </div>
                <div className="text-[8px] text-gray-400">
                  VID: {item.ref_id}
                </div>
              </div>

              {/* Product info */}
              <div className="w-full flex flex-col justify-between leading-tight">
                <div className="font-semibold text-[12px] text-gray-800 line-clamp-2">
                  {item.name}
                </div>
                {item.variant_name && (
                  <div className="text-[11px] text-gray-500">
                    {item.variant_name}
                  </div>
                )}
              </div>

              {/* Price and total */}
              <div className="flex flex-col gap-0.5 justify-end w-[30%] text-right">
                <div className="flex justify-end gap-1 items-center">
                  <div className="text-[11px]">{price}</div>
                  <div>×</div>
                  <div>{quantity}</div>
                </div>

                {discount > 0 && (
                  <div className="text-[10px] text-green-600">
                    -{discount} OFF
                  </div>
                )}

                <div className="font-semibold text-sm text-green-700">
                  {total} {currency}
                </div>
              </div>
            </div>

            {/* Divider */}
            {idx !== items.length - 1 && (
              <div className="px-2">
                <div className="w-full h-[0.5px] bg-gray-200"></div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OrderCardOrderItemsList;